module.exports = __webpack_public_path__ + "static/media/auction-collect-demo-t3.3360705f.nom";